module.exports = __webpack_public_path__ + "img/TZS.a071e7f3.svg";